// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__pFDDB","block":"Footer_block__5j+PC","info":"Footer_info__5fE5J"};